var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-col',{directives:[{name:"show",rawName:"v-show",value:(!_vm.control.children[0].options.treeView),expression:"!control.children[0].options.treeView"}],staticClass:"ant-col",attrs:{"span":_vm.colSpan}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }